import components from '../components'
import { page } from '@/mixins/index'
import module from './module'
import store from 'store'
import qs from 'qs'
import { deepEqual, getQueryParams, getParameter, getCookie, setCookie, removeCookie, isLogin } from '@/utils/common'
import shop from '@/utils/shop'
import { Popup } from '@vivo/shop-ui-h5'
import ReservePopup from '../components/reserve-popup'
import Recycle from '@/components/recycle'
import skuEventBus from '../components/sku-select/eventBus'
import env from '@/utils/clientEnv'
import API from '@/api'
import Order from '@vivo/activity-order'
import { app } from '@/utils'
import { asyncLoadJs } from '@/utils/dom'
import BrowserTabEmitter from '@/utils/browserTabEmitter'
import config from '@/config'
export default {
  name: 'product-detail',
  mixins: [page('detailv3', module)],
  components: {
    Popup,
    ReservePopup,
    Order,
    Recycle,
    ...components
  },
  data() {
    return {
      spuIdTemp: this.$route.params.spuId || 0, // 方便模板渲染内切换sku时获取spu参数
      showSelect: false,
      skuInit: false,
      isGroupon: false, // 是否拼团商详
      isGrouponLottery: false, // 是否一分团
      isShowAppointment: false, // 是否展示预约弹窗,
      startTime: Date.now(),
      isShowThreeDimensional: false, // 是否展示360
      threeDimensionalUrl: '', // 360链接
      show3D: false, // 是否展示360
      isScroll: false, // 是否滚动
      draft: 1, // 是否是草稿 1 正式 0 草稿
      ordered: false,
      isNoShare: 0,
      isSixVerion: env.androidLevel <= 7 && env.androidLevel >= 6 && env.isVivoApp,
      flag: false, // 是否开启定位
      maxPageYOffset: 0, // 页面最大距顶部高度，用于计算用户浏览高度
      isTemplate: this.$route.query.isTemplate || 0, // 是否是模板模式
      isShowProductIframe: false,
      productIframeSrc: ''
    }
  },
  computed: {
    currentSuite() {
      return this.selectParams?.currentSuite
    },
    installmentParams() {
      return this.skuInfo?.commoditySkuBaseInfo?.skuId + '&' + this.mainPrice
    },
    // 是否是白名单
    isWhite3D() {
      return env.isWhite3D
    },
    // spu是否可售标识 0：不可售 1：可售 只根据spu维度去展示购买按钮状态
    canBuy() {
      return !!this.spuInfo?.canSaleFlag || false
    },
    // 360度展示标识 0：不展示 1：展示
    circleFlag() {
      return this.spuInfo?.circleFlag == 1
    },
    // 大促礼盒分为背景图、自定义氛围抢购设置背景图
    skuPriceAreaBg() {
      // 大促礼盒背景图设置
      if (this.isBigpromotion && this.commodityBigPromotion && this.commodityBigPromotion.appearImgUrl) {
        return {
          backgroundImage: `url(${this.commodityBigPromotion.appearImgUrl})`,
          backgroundSize: '100% 100%'
        }
      }
      // 自定义氛围抢购背景图设置
      if (this.hasCustomAtmosphereBg) {
        return {
          backgroundImage: `url(${this.customAtmosphereInfo.backgroundPic})`,
          backgroundSize: '100% 100%'
        }
      }
      return {}
    }
  },
  watch: {
    currentSuite: {
      handler(newVal, oldVal = {}) {
        if (oldVal.id !== newVal.id && !this.isGroupon) {
          // 拼团不展示积分
          this.getPointInfo()
        }
      }
    },
    installmentParams() {
      // 价格和skuId变化的时候请求分期信息
      !this.isLottery && this.getInstallment()
    }
  },
  created() {
    const self = this
    // 获取url参数标识是否是离屏模板，否则收回请求权限
    if (!this.isTemplate) {
      this.getInitData()
      setCookie('shop-feature-id', '')
      // removeCookie('shop-feature-id')
      // 优先取链接参数里的时间戳
      const currentTime = new Date().getTime()
      const clickTime = getParameter('timestamp') || currentTime
      const duration = currentTime - clickTime
      self['CHANGE_DURATION']({ clickTime: clickTime, duration: duration })
    } else {
      self.SET_TEMPLATE_FLAG(self.isTemplate)
      // 客户端进行调用，从原始url中解析业务参数
      if (!window.activeTemplate) {
        window.activeTemplate = async function (url, data, timestamp) {
          console.log('activeTemplate', url, data, timestamp)
          // 如果不是商详则直接跳转url
          const uri = decodeURIComponent(url)
          const reg = /^http(s|):\/\/(\w+|)shop.vivo.com(.cn|)(:\d+|)\/wap\/(product\/\d{1,}).*/
          if (uri && !reg.test(uri)) {
            location.replace(uri)
            return
          }
          // 替换成真实链接
          const routeInfo = self.$router.resolve(uri.replace(location.origin + '/wap', ''))
          await self.$router.replace(routeInfo.route)
          // 添加特性打点，服务端日志采集后大数据分析订单来源(通用特性，也可为后面其它实验串行使用)；1离屏渲染 1-1返回首屏，1-2返回部分数据
          setCookie('shop-feature-id', '1')
          if (data) {
            const res = JSON.parse(decodeURIComponent(data))
            if (res.spu) {
              self['CHANGE_PAGE_INIT'](true)
              self['SET_SPU_INFO'](res.spu)
            }
            self['SET_SKU_INFO'](res.sku || res)
            setCookie('shop-feature-id', '1-1')
            if (res?.specItemColor) {
              setCookie('shop-feature-id', '1-2')
            }
          }
          self.getInitData(uri)
          // 优先取回调参数里的时间戳
          const currentTime = new Date().getTime()
          const clickTime = timestamp || currentTime
          const duration = currentTime - clickTime
          self['CHANGE_DURATION']({ clickTime: clickTime, duration: duration })
          // 兼容离屏渲染场景，商详页离开上报埋点停留时长
          self.startTime = clickTime
        }
      }
      // 客户端调用重置页面
      if (!window.clearTemplateContent) {
        // 慎用！重置问题较多，最终采用客户端reload模板方式
        window.clearTemplateContent = function () {
          self['RESET_ALL_DATA']()
          // 关闭拼团、v秒杀、会员先享购活动结束弹层
          self.closeEndPopup()
          // 评价列表重置
          self.$refs?.evaluateInfo?.closeAll()
          //  成功回调
          app.templateDetachSuccess()
        }
      }
      // 模板加载成功后，调用JSBridge通知客户端
      app.templateLoadSuccess()
    }
  },
  beforeMount() {
    if (env.isVivoApp) {
      let haveMeta = false
      const metaTags = document.getElementsByTagName('meta')
      for (let i = 0; i < metaTags.length; i++) {
        if (metaTags[i].getAttribute('name') == 'color-scheme') {
          haveMeta = true
          break
        }
      }
      if (!haveMeta) {
        var meta = document.createElement('meta')
        meta.name = 'color-scheme'
        meta.content = 'light dark'
        document.getElementsByTagName('head')[0].appendChild(meta)
      }
    }
  },
  mounted() {
    skuEventBus.$on('skuChange', ({ skuId, oldSkuId, name }) => {
      if (oldSkuId) {
        this['UPDATE_VIP_FIRST_BUY_DISABLE'](false)
        this['SET_AUTO_SHARE'](false)
        this['SET_SKU_INFO']({
          ...this.skuInfo,
          recycleOneStopActivity: null,
          commodityActivities: null
        })
        const spuId = this.spuIdTemp
        let { channel, token, vvshopReferee, purchaseChannel, liveRoomId, liveSceneId } = this.productQuery
        if (this.isGroupon) {
          channel = 'group'
        }
        if (this.isGrouponLottery) {
          channel = 'lottery'
        }
        this.getSimpleSku({
          spuId,
          skuId,
          channel,
          token,
          vvshopReferee,
          purchaseChannel,
          liveRoomId,
          liveSceneId,
          showToast: true
        })
        this.getDetailSku({ spuId, skuId, channel, token, vvshopReferee, purchaseChannel, liveRoomId, liveSceneId })
        this.getRecommend({ spuId, skuId })
        // 更新已选信息
        this.updateSelectParams({
          name,
          number: 1,
          fqNum: 0,
          laser: false,
          currentSuite: {}
        })
        // 埋点上报数据
        this.trackPV()
      }
    })
    const bte = new BrowserTabEmitter()
    bte.on('bte:changeCartNumber', () => {
      this.fetchCartNumber()
    })
  },
  destroyed() {
    window.removeEventListener('visibilitychange', e => this.leaveTrack(e))
  },
  methods: {
    asyncLoadCanvasJs() {
      return asyncLoadJs(`${config.path.shopFrontBaseUrl}static/lib/html2canvas974.min.js`)
    },
    async getInitData(url) {
      let query = this.getQuery(url)
      let spuId = this.$route.params.spuId
      this.draft = this.$route.query.draft
      this.isNoShare = this.$route.query.isNoShare || 0
      if (this.$route.query.autoShare == 1) {
        this.SET_AUTO_SHARE(true)
      }
      const isIframe = window && window.self !== window.top
      let res = isIframe ? false : await env.isWeChatApp()
      if (res) {
        let { skuId, colorSkuid, ...others } = this.$route.query
        const skuIdStr = skuId || colorSkuid ? `&skuId=${skuId || colorSkuid}` : ''
        let otherParams = qs.stringify(others, {
          indices: false
        })
        let url = `/pages/product/index?spuId=${spuId}${skuIdStr}`
        if (otherParams) {
          url += `&${otherParams}`
        }
        if (history.length === 1) {
          // eslint-disable-next-line
          wx.miniProgram.redirectTo({
            url
          })
        } else {
          // eslint-disable-next-line
          wx.miniProgram.navigateTo({
            url
          })
          setTimeout(function () {
            history.back()
          }, 1000)
        }
      } else {
        setTimeout(() => {
          try {
            this.getLocation()
          } catch (e) {
            console.warn('getLocation,定位失败')
          }
        }, 100)
        if (this.isTemplate) {
          // 离屏渲染，解析url参数
          const realUrl = new URL(url)
          spuId = query.spuId
          // 兼容url中没有spuId参数的场景
          if (!spuId) {
            const matchList = /product\/(\d{1,})/g.exec(realUrl.pathname)
            if (matchList) {
              spuId = matchList[1]
            } else {
              // 匹配不了商品返回列表页面
              location.replace('/product/phone')
            }
          }
          spuId = this.spuIdTemp = spuId
          this.draft = query.draft
          this.isNoShare = query.isNoShare
          // 埋点公共参数url处理
          await store.dispatch('track/updateTrackData', {
            path: realUrl.path,
            argStr: realUrl.search.split('?')[1]
          })
        }
        let {
          skuId,
          colorSkuid,
          channel,
          token,
          calcForEstimated,
          vvshopReferee,
          purchaseChannel,
          liveRoomId,
          liveSceneId
        } = query
        // 拼团
        if (this.$route.name == 'groupon') {
          channel = 'group'
          this.isGroupon = true
        }
        if (channel == 'group') {
          this.isGroupon = true
        }
        // 一分团
        if (channel == 'lottery') {
          this.isGroupon = true
          this.isGrouponLottery = true
        }
        // 获取存储的省市区或者地址
        let cacheData = this.$ls.get('addressData') || ''
        this['SET_CACHE_ADDRESS_DATA'](cacheData)
        // 判断是否有活动频道
        await this.init({
          spuId,
          skuId: skuId || colorSkuid,
          channel,
          token,
          calcForEstimated,
          vvshopReferee,
          purchaseChannel,
          liveRoomId,
          liveSceneId,
          isPre: 1,
          cacheData
        })
          .then(() => {
            this['SET_VIDEO_INIT_FLAG'](true)
            if (this.isSeeOther) {
              this.getRecommend({ spuId, skuId: this.skuId })
            }
            this.getRemarkList()
            this.deal3D(this.draft)
            // 异步请求html2canvas.js
            this.asyncLoadCanvasJs().then(() => {
              // 仅首次进入页面携带自动分享参数-执行自动分享
              if (this.autoShareFlag) {
                this.$refs.productHeader && this.$refs.productHeader.doShare()
              } else {
                this.$refs.productHeader && this.$refs.productHeader.initHtmlCanvas()
              }
            })
            // 埋点上报数据
            this.trackPV()
            // 设置商详页分享生成海报展示
            app.setPosterShareStatus(!this.posterEnable)

            // 创建web模板
            this.$nextTick(() => {
              if (this.isTemplate) {
                app.preloadTemplate({
                  key: 'shop'
                  // ,url: 'https://shop.vivo.com.cn/wap/app/default.html?isTemplate=1'
                })
              }
            })
          })
          .catch(err => {
            console.log(err)
            // 商品不存在，或者其他报错返回列表页面
            location.replace('/product/phone')
          })
        this.bindScrollEvent()
        shop.updateViewHistory(spuId)
        // 监听页面离开
        // https://www.cnblogs.com/zhangruiqi/p/9868983.html
        window.addEventListener('visibilitychange', e => this.leaveTrack(e))
      }
    },
    getQuery(url) {
      if (url) {
        const realUrl = new URL(url)
        const query = getQueryParams(realUrl.search)
        this['CHANGE_QUERY'](query)
      }
      return this.productQuery
    },
    getLocation() {
      app.getLocation(
        res => {
          // 兼容返回成功但没有经纬度的场景
          if (res.longitude && res.latitude) {
            this.SET_POSITION({
              longitude: res.longitude,
              latitude: res.latitude
            })
            this['SET_LBS'](true)
          }
          this.flag = true
        },
        () => {
          const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0
          }
          navigator.geolocation.getCurrentPosition(
            res => {
              let crd = res.coords
              this.SET_POSITION({
                longitude: crd.longitude,
                latitude: crd.latitude
              })
              this.flag = true
              this['SET_LBS'](true)
            },
            () => {
              this.flag = true
              this['SET_LBS'](false)
            },
            options
          )
        }
      )
    },
    change({ name, number = 1, fqType = 0, fqBank = 0, fqNum = 0, laser = false, currentSuite = null, service = {} }) {
      const selectParams = { name, number, fqType, fqBank, fqNum, currentSuite, service, laser }
      const oldSelectParams = this.selectParams
      if (!deepEqual(selectParams, oldSelectParams)) {
        this.updateSelectParams(selectParams)
        !this.isLottery && this.getInstallment()
      }
    },
    // 展示评价列表，banner模块的评价气泡需要用
    showEvaluateList() {
      this.$refs.evaluateInfo && this.$refs.evaluateInfo.showRemarkList()
    },
    // 定位到详情
    toProductDetail() {
      this.$refs.productHeader && this.$refs.productHeader.tabPostion('introduction')
    },
    // 展示预约弹窗
    showAppointment(isShow) {
      if (this.ordered) {
        return false
      }
      this.isShowAppointment = isShow
      this.$refs['order'].doAppoint()
      this['SET_VIDEO_CAN_PLAY_STATE'](!isShow)
    },
    // 查看推荐商品
    seeOther() {
      // 关闭sku选择弹层
      if (this.$refs['skuSelect']?.beforeClose) {
        this.$refs['skuSelect'].beforeClose()
      }

      this.showSkuSelect(false)
      // 关闭评论列表弹层
      this.$refs.evaluateInfo && this.$refs.evaluateInfo.closeAll()
      // 关闭360弹层
      this.isShowThreeDimensional = false
      setTimeout(() => {
        return document.querySelector('#guess-like')?.scrollIntoView()
      }, 500)
    },
    // 关闭已选弹层
    closeSkuSelect() {
      if (this.$refs['skuSelect']) {
        this.$refs['skuSelect'].beforeClose()
      }
      this.showSkuSelect(false)
    },
    // 关闭适用说明弹层
    handlePartAdaptedClose() {
      this.CHANGE_ADAPTED_POPUP_SHOW(false)
    },
    handlePartListClose() {
      this.CHANGE_PART_LIST_POPUP_SHOW(false)
    },
    // 查看更多配件信息
    async gotoPartList(type) {
      await this.queryPartAdaptedList()
      if (type == 1 && this.partAdaptedObject.list.length == 0) {
        this.$toast('暂无其他原装配件')
        return
      }
      this.CHANGE_ADAPTED_POPUP_SHOW(false)
      setTimeout(() => {
        this.CHANGE_PART_LIST_POPUP_SHOW(true)
      }, 100)
    },
    leaveTrack() {
      // 用户离开了当前页面
      if (document.visibilityState === 'hidden') {
        this.$track({
          cfrom: '081|001|98|077',
          event_id: '081|001|98|077',
          duration: Date.now() - this.startTime,
          depth_max: document.body.clientHeight + this.maxPageYOffset,
          ...this.commonTrackData
        })
        this.startTime = Date.now()
      }
    },
    trackPV() {
      // 埋点上报数据
      // todo
      this.$track({
        cfrom: 5300,
        event_id: '081|001|55|077',
        is_done: 1,
        isno_share: this.isNoShare,
        video_id: this.spuInfo.commodityLive?.liveRoomId,
        id: this.spuInfo.commodityLive?.liveSceneId,
        isno_stock: this.isSpot ? 1 : 2, // 是否支持现货购买
        shopfeatureid: getCookie('shop-feature-id'), // 重要：离屏渲染转化率统计
        is_template: this.isTemplate, // 重要：离屏渲染转化率统计
        fcp: this.initDuration, // 分析fcp时长与转化的关系
        lcp: this.firstScreenDuration, // 分析lcp时长与转化的关系
        performance: performance?.timing || '', // 页面性能
        ...this.commonTrackData
      })
    },
    resetSpecRulePosition() {
      this.$refs.productHeader.tabChange('tabContent2')
    },
    backCloseThreeDimensional() {
      this.isShowThreeDimensional = false
    },
    open3D() {
      this.isShowThreeDimensional = true
      // 360度展示模块-3D按钮点击
      API.logAll({
        cfrom: '207|001|01|077',
        event_id: '207|001|01|077',
        sku_id: this.skuId
      })
    },
    // 处理3d显示逻辑
    async deal3D(draft) {
      const isIphone6 = navigator.userAgent.includes('iPhone 6')
      if (!this.isWhite3D || !this.circleFlag || isIphone6) this.show3D = false
      else {
        const spuModel = this.spuInfo?.commoditySpu?.modelName || ''
        const params = {
          modelName: spuModel,
          state: draft == '0' ? 0 : 1
        }
        // 获取官网接口360度资源
        API.getThreeDimensionalData(params)
          .then(res => {
            if (res) {
              this.show3D = true
              this.threeDimensionalUrl = `https:${res}?source=vivoShop`
            }
          })
          .catch(err => console.log('err', err))
      }
    },
    /**
     * 绑定滚动事件，用于获取推荐内容
     */
    bindScrollEvent() {
      window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // 获取最大距页面顶部高度
        if (scrollTop > this.maxPageYOffset) {
          this.maxPageYOffset = scrollTop
        }
        if (scrollTop > 20 && !this.isScroll) {
          this.isScroll = true
          this.getRecommend({ spuId: this.spuId, skuId: this.skuId })
        }
      })
    },
    doAppoint() {
      if (this.ordered) {
        return false
      }
      this.$refs['order'].doAppoint()
    },
    toast(txt) {
      this.$toast(txt)
    },
    // 立即换新
    async goToRenew(opts) {
      const trackFrom = opts.trackFrom || 0
      if (trackFrom != 2 && !this.isSelfModel) {
        // 如果不是来源于悬浮条活动，且无估价信息 展示选择旧机弹层
        this.goToRenewSelect(opts)
        return
      }

      this.closeSkuSelect()
      // 商详页进入估价弹层时先校验登录
      const res = await isLogin()
      if (!res) {
        app.login()
        return
      }
      // 处理加价购场景
      this.dealExtraProduct()
      // let recycleEvaluateUrl =
      //   'https://test-vivo-m.huishoubao.com/evaluate?v=1&show_title=0&hide_title=1&commonImmersive=1&level=3&openId=T9y_HfIN_R9SjmMJB4QBIu7rbpH0obey0IzuMgLFY0U&modelCode=VBEM2XRZME&appId=XiWHNRiZ&sign=c1489714eee421b0e877bbcb95d37c334d76b342b93b0319bab618c74cfecd0a&signType=HS256&timestamp=20231016172325&supplierId=2'
      const evaluateUrl = `${this.recycleEvaluateUrl}&v_from_iframe=1&v_evaluate_type=0&v_rule_url=${encodeURIComponent(
        this.renewRuleUrl
      )}&v_onestop=1`
      // 服务端验签要求，将业务参数合并
      const params = Object.assign({}, this.getSelectParams, {
        spuId: this.spuId,
        laser: false,
        additionCommodity: [],
        skuCode: this.skuCode,
        salePrice: this.skuInfo.commoditySkuBaseInfo.salePrice,
        fromDetail: 1,
        recycleMode: 0, // 本机
        trackFrom, // 埋点配置
        evaluateUrl: evaluateUrl // 估价页url服务端返回
      })
      const transferQ = window.btoa(qs.stringify(params, { indices: false }))
      // 展示以旧换新弹层
      this.setRecycleIframeParams({
        title: '精准估价',
        iframeSrc: `${evaluateUrl}&v_transfer_q=${transferQ}`
        // 'http://mvivoshop.vivo.com.cn:3000/wap/recycle/result?v_evaluate_type=1&v_from_iframe=1&v_transfer_q=c2t1SWQ9MTI3OTYmbnVtPTEmZnFOdW09MCZsYXNlcj1mYWxzZSZsb25naXR1ZGU9MTE0LjA0MjQ3MDQmbGF0aXR1ZGU9MjIuNTgzNzA1NiZzcHVJZD0xMTAwMzExOSZza3VDb2RlPTU2NTIwMDImc2FsZVByaWNlPTE1MDAmZnJvbURldGFpbD0xJnJlY3ljbGVNb2RlPTAmZXZhbHVhdGVVcmw9aHR0cHMlM0ElMkYlMkZkYW5naHVhbi12aXZvLndhbnlvbC5jb20lMkZzdGF0aWMlMkZpbmRleC5odG1sJTIzJTJGcHJvcGVydHklM0Zwcm9kdWN0SWQlM0QlMjZwcm9kdWN0TWF4UHJpY2UlM0QlMjZjYXRlZ29yeUlkJTNEMiUyNnNob3dfdGl0bGUlM0QwJTI2aGlkZV90aXRsZSUzRDElMjZzaG93U2hhcmVCdG4lM0QwJTI2c2hvd01lbnVCdG4lM0QwJTI2c2hvd0Jyb3dzZXJMaW5rJTNEMCUyNnNob3dDb3B5TGluayUzRDAlMjZjaGFubmVsSWQlM0QxMTM3ODMwJTI2Y29tbW9uSW1tZXJzaXZlJTNEMSUyNmxldmVsJTNEMyUyNm9wZW5JZCUzRFQ5eV9IZklOX1I5U2ptTUpCNFFCSXU3cmJwSDBvYmV5MEl6dU1nTEZZMFUlMjZtb2RlbENvZGUlM0QyMzI0JTI2YXBwSWQlM0RvbmxpbmV2aXZvJTQwUEMlNDAxJTIzJTQwN3dsbGVlNTclMjZzaWduJTNEOWI3YTIxZWJhNDJkMGE1ODBkNzQ4N2NlYzBhMTllOTBhMjQ2YTgzZTA2YTdmZDFjNDIxNzE2MTM2MGVhZjMxMSUyNnNpZ25UeXBlJTNESFMyNTYlMjZ0aW1lc3RhbXAlM0QyMDIzMTAyMDE2NTk1MSUyNnZfZnJvbV9pZnJhbWUlM0QxJTI2dl9ldmFsdWF0ZV90eXBlJTNEMCUyNnZfcnVsZV91cmwlM0RodHRwcyUyNTNBJTI1MkYlMjUyRm1zaG9wYWN0LnZpdm8uY29tLmNuJTI1MkZ2aXZvc3BhY2UlMjUyRndrMjMwOTE1MTBkNzE0M2IlMjUzRnNob3dfdGl0bGUlMjUzRDElMjUyNmVsYXBzZWR0aW1lJTI1M0Q2NDQ5OTAzOSUyNTI2aDVKdW1wQmFja0ZsYWclMjUzRDElMjUyNndrX29wZW50aW1lJTI1M0QxNjk3Nzc0MTEwOTU1JTI1MjZzaGFyZV9jaGFubmVsJTI1M0QwNyUyNnZfb25lc3RvcCUzRDE=&formCode=mnOaDfE9k9%2BR7cLmDZzsTw%3D%3D&appId=1VY4ZhAr&modelCode=2324&timestamp=20231020170003&signType=HS256&sign=188ce80f38fef3c17702078c9cfa922e31df25633f8101e3dafddde34e1b4a17'
      })
      window.top.postMessage(
        {
          event: 'change:history',
          data: {
            url: `${evaluateUrl}&v_transfer_q=${transferQ}`,
            type: 'forwards',
            title: '精准估价'
          }
        },
        '*'
      )
      this.showRecycleIframe(true)
      // 供应商页面精准估价曝光埋点
      this.$track({
        event_id: '250|001|02|077',
        from: trackFrom || 0, // 0:其他、1:商详页大卡;2:商详页悬浮条;3:商详页活动弹层;4:商详页选购弹层;5:活动首页
        is_recycle: 0
      })
    },
    // 以旧换新活动-选择机型
    async goToRenewSelect(opts) {
      this.closeSkuSelect()
      // 商详页进入估价弹层时先校验登录
      const res = await isLogin()
      if (!res) {
        app.login()
        return
      }
      // 处理加价购场景
      this.dealExtraProduct()
      const selectUrl = `${
        this.linkBase
      }/recycle/phones/index?&v_from_iframe=1&v_evaluate_type=0&v_rule_url=${encodeURIComponent(
        this.renewRuleUrl
      )}&v_onestop=1&detail_activity_entry=1`
      const params = Object.assign({}, this.getSelectParams, {
        spuId: this.spuId,
        laser: false,
        additionCommodity: [],
        skuCode: this.skuCode,
        salePrice: this.skuInfo.commoditySkuBaseInfo.salePrice,
        fromDetail: 1,
        trackFrom: opts.trackFrom || 0, // 埋点配置
        recycleMode: 1 // 旧机
      })
      const transferQ = window.btoa(qs.stringify(params, { indices: false }))
      const iframeParams = {
        title: '选择旧机',
        iframeSrc: `${selectUrl}&v_transfer_q=${transferQ}`
        // 'http://mvivoshop.vivo.com.cn:3000/wap/recycle/result?v_evaluate_type=1&v_from_iframe=1&v_transfer_q=c2t1SWQ9MTMzNzMmbnVtPTEmZnFOdW09MCZsYXNlcj1mYWxzZSZsb25naXR1ZGU9MTEzLjk4MDIxMTImbGF0aXR1ZGU9MjIuNTY0MDQ0OCZzcHVJZD0xMTAwMzQ1MiZza3VDb2RlPTU2NjQ3NDMmc2FsZVByaWNlPTQzOTkmZnJvbURldGFpbD0xJnRyYWNrRnJvbT0xJnJlY3ljbGVNb2RlPTEmZXZhbHVhdGVVcmw9aHR0cHMlM0ElMkYlMkZzaG9wLnZpdm8uY29tLmNuJTJGd2FwJTJGZGFuZ2h1YW4lMkZpbmRleC5odG1sJTIzJTJGcHJvcGVydHklM0Zwcm9kdWN0SWQlM0QlMjZwcm9kdWN0TWF4UHJpY2UlM0QlMjZjYXRlZ29yeUlkJTNEMiUyNnNob3dfdGl0bGUlM0QwJTI2aGlkZV90aXRsZSUzRDElMjZzaG93U2hhcmVCdG4lM0QwJTI2c2hvd01lbnVCdG4lM0QwJTI2c2hvd0Jyb3dzZXJMaW5rJTNEMCUyNnNob3dDb3B5TGluayUzRDAlMjZjaGFubmVsSWQlM0QxMTM3ODMwJTI2Y29tbW9uSW1tZXJzaXZlJTNEMSUyNmxldmVsJTNEMyUyNm9wZW5JZCUzRFQ5eV9IZklOX1I5U2ptTUpCNFFCSXU3cmJwSDBvYmV5MEl6dU1nTEZZMFUlMjZtb2RlbENvZGUlM0QxNDM3JTI2YXBwSWQlM0RvbmxpbmV2aXZvJTQwUEMlNDAxJTIzJTQwN3dsbGVlNTclMjZzaWduJTNENjcyMWNmMzMyMmRlMTYzNmZiNDIxMTU3MzhiY2M2MWE3NDI2YjA4NTI3MmFjNTQ2ZjJmNGFjYzIwYzA0MTM1YiUyNnNpZ25UeXBlJTNESFMyNTYlMjZ0aW1lc3RhbXAlM0QyMDIzMTEyMzA5MjA1MSUyNnZfZnJvbV9pZnJhbWUlM0QxJTI2dl9ldmFsdWF0ZV90eXBlJTNEMCUyNnZfcnVsZV91cmwlM0RodHRwcyUyNTNBJTI1MkYlMjUyRnNob3Audml2by5jb20uY24lMjUyRm15JTI1MkZyZWN5Y2xlJTI1MkZjYXNoQ291cG9uJTI1MkZpbmRleCUyNnZfb25lc3RvcCUzRDE=&formCode=13236186&appId=1VY4ZhAr&modelCode=1437&timestamp=20231123092128&signType=HS256&sign=f860ea4954a8e29d2173306433ab4b406101383362dc77b7a3da5733a52ea75f'
      }
      this.$refs.recycleModalRef?.locationTo(iframeParams)
      // 展示以旧换新弹层
      this.setRecycleIframeParams(iframeParams)
      this.showRecycleIframe(true)
    },
    /**
     * @description: 唤起切换规格弹层 987更新为唤起iframe嵌入机型规则已选页面
     */
    changeRecycleSkuShow(params) {
      if (!this.productIframeSrc) {
        let url = `${this.linkBase}/product/select?`
        const queryParams = Object.assign({}, this.getSelectParams, {
          ...this.productQuery, // 增加路由channel等等路由携带信息
          spuId: this.spuId,
          skuId: this.skuId,
          source: 20,
          refPage: 1
        })
        this.productIframeSrc = `${url}${qs.stringify(queryParams, { indices: false })}`
        this.bindProductIframeMessage()
      } else {
        // 更换规格切换到当前首页展示的数据
        this.$refs.productIframeRef?.contentWindow.postMessage(
          {
            event: 'reInit:sku',
            data: params?.params || { skuId: this.skuId, selectParams: null }
          },
          '*'
        )
      }
      this.isShowProductIframe = true
    },
    /**
     * @description: 987 新增监听规格选择页面postMessage逻辑
     * @return {*}
     */
    bindProductIframeMessage() {
      window.addEventListener('message', this.receiveSpecSelectMessage, false)
    },
    /**
     * @description: 以旧换新更换规格changeSpec回调
     * @return {*}
     */
    receiveSpecSelectMessage(message) {
      const data = message.data
      // 新机-更换规格
      if (data.event == 're:change:sku') {
        const skuInfo = data.data.skuInfo
        if (
          data.data.extCode ||
          skuInfo.commoditySkuDiscount.commodityDiscountType === 'deposit' ||
          skuInfo.commoditySkuBaseInfo.salePrice === 999999
        ) {
          // 商品异常场景处理：1：已售罄 2：立即预约 3：到货通知 4：下架 5：仅作赠品、定金预售、待发布商品
          // 保留弹层展示
          return
        } else {
          this.isShowProductIframe = false
          if (this.isShowRecycleIframe) {
            this.$refs.recycleModalRef?.confirmSpec(data.data)
          }
          // TODO-tyh：最终选择同步更新商详页提交，则监听到更换规格切换机型后，则触发商详页skuChange
          // start
          // 根据skuInfo更新存储记录，避免二次请求库存差异出现提示
          this['SET_ALL_SKU_DETAIL_DATA']({ ...data.data.skuInfo, id: data.data.skuId })
          // 通知订阅组件sku发生了变化
          skuEventBus.$emit('skuChange', {
            skuId: data.data.skuId,
            oldSkuId: this.skuId,
            name: data.data.selectParams?.name
          })
          // 更新已选参数
          this.updateSelectParams(data.data.selectParams)
          // end
        }
        return
      }
    },
    // 以旧换新弹层更换规格（非skuId）
    confirmSpec() {
      console.log('confirmSpec', this.skuId)
      this.$refs.recycleModalRef?.confirmSpec({
        skuId: this.skuId,
        selectParams: this.selectParams,
        formateInfo: this.productRecycleInfo.formateInfo
      })
      this.closeSkuSelect()
    },
    dealExtraProduct() {
      const { selectParams } = this
      if (selectParams.additionCommodity.length > 0) {
        this.$toast('选择一站式换新服务后将取消加价购选择，以便享受更好服务')
      }
    }
  }
}
